import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import userConfigs from '../../../entity/userConfig';
import BaseComponent from '../../../components/BaseComponent';

class UserPage extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.config = { ...userConfigs };
    this.getResponse();
  }
}

const mapStateToProps = (state: {
  app: { isAuthenticated: any; user: any };
}) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

const UserPageWrapper = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return (
    <UserPage
      {...props}
      navigate={navigate}
      location={location}
      params={params}
    />
  );
};

export default connect(mapStateToProps)(UserPageWrapper);
